export const DOMAIN = 'buyers';
export const SUB_DOMAIN = 'caterpillars';
export const BI_EVENT_GROUPS = {
    PAGE_VIEW: 'page_view',
    USER_ACTION: 'user_action',
    USER_IMPRESSION: 'user_impressions'
};

export const BI_ACTION_TYPES = {
    CLICK: 'click'
};
